import React from 'react';
import { useInView, Overline } from './shared';

const MappingVisual = () => {
  const [ref, inView] = useInView(0.35);
  return (
    <section ref={ref} className={`bg-[#0a0a0a] text-white py-28 md:py-40 px-6 md:px-12 border-t border-white/10 ${inView ? 'hv2-active' : ''}`} data-testid="hv2-mapping">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-5 gap-14 items-center">
        <div className="lg:col-span-2">
          <Overline dark>Signature Intelligence</Overline>
          <h2 className="font-outfit text-5xl md:text-7xl font-medium leading-[1.02] tracking-tighter">
            <span className="block hv2-word hv2-word-1">MAP.</span>
            <span className="block hv2-word hv2-word-2 text-white/60">PLAN.</span>
            <span className="block hv2-word hv2-word-3 text-[#00AEEF]">CLEAN.</span>
          </h2>
          <p className="font-manrope text-lg text-white/50 mt-8 max-w-sm leading-relaxed">
            A 360° laser scan builds the map, AI plans the route, and LumineX 300 cleans it — systematically.
          </p>
        </div>
        <div className="lg:col-span-3">
          <svg viewBox="0 0 800 520" className="w-full h-auto" role="img" aria-label="Animated visualization of LumineX 300 laser-mapping a home floor plan and cleaning it row by row">
            {/* Floor plan walls */}
            <g className="hv2-walls" fill="none" stroke="#3f3f46" strokeWidth="4">
              <rect x="20" y="20" width="760" height="480" rx="6" />
              <line x1="300" y1="20" x2="300" y2="270" />
              <line x1="300" y1="350" x2="300" y2="500" />
              <line x1="300" y1="270" x2="540" y2="270" />
              <line x1="620" y1="270" x2="780" y2="270" />
            </g>
            {/* Furniture */}
            <g className="hv2-furniture" fill="#1c1c1f" stroke="#2b2b30" strokeWidth="2">
              <rect x="60" y="60" width="150" height="80" rx="8" />
              <rect x="620" y="60" width="110" height="150" rx="8" />
              <circle cx="160" cy="380" r="48" />
              <rect x="420" y="360" width="200" height="90" rx="8" />
            </g>
            {/* Laser scan sweep */}
            <g className="hv2-scan" stroke="#00AEEF" strokeWidth="1.5" opacity="0.8">
              <line x1="400" y1="260" x2="770" y2="40" />
              <line x1="400" y1="260" x2="770" y2="480" />
            </g>
            {/* Cleaning route (boustrophedon) */}
            <path
              className="hv2-route"
              d="M 60 470 H 740 M 740 430 H 60 M 60 390 H 380 M 700 390 H 740 M 740 330 H 60 M 60 230 H 260 M 340 230 H 740 M 740 180 H 60 M 60 170 V 470"
              fill="none" stroke="#0057B8" strokeWidth="5" strokeLinecap="round" strokeDasharray="4000" strokeDashoffset="4000"
            />
            {/* Robot */}
            <circle className="hv2-robot" r="16" fill="#ffffff" cx="60" cy="470">
              <animate attributeName="cx" values="60;740;740;60;60;380;700;740;740;60" dur="9s" begin="3s" repeatCount="indefinite" />
              <animate attributeName="cy" values="470;470;430;430;390;390;390;330;330;330" dur="9s" begin="3s" repeatCount="indefinite" />
            </circle>
            <circle className="hv2-robot-ring" r="24" fill="none" stroke="#00AEEF" strokeWidth="2" cx="60" cy="470">
              <animate attributeName="cx" values="60;740;740;60;60;380;700;740;740;60" dur="9s" begin="3s" repeatCount="indefinite" />
              <animate attributeName="cy" values="470;470;430;430;390;390;390;330;330;330" dur="9s" begin="3s" repeatCount="indefinite" />
            </circle>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default MappingVisual;
